// extracted by mini-css-extract-plugin
module.exports = {"btn_round":"styles_btn_round__2ZMdt"};